<template>
  <div>
    <v-table density="compact" v-if="list_code_reduction.list.length > 0">
      <thead>
        <tr>
          <th class="text-left">Code</th>
          <th class="text-left">Réduction</th>
          <th class="text-left">S'applique sur</th>
          <th class="text-left">Date de validité</th>
          <th class="text-left">Nombre d'utilisation</th>
          <th class="text-left">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in list_code_reduction.list" :key="item.id">
          <td>
            <v-chip density="compact">{{ item.nom }}</v-chip>
          </td>
          <td>{{ get_valeur_reduction(item) }}</td>
          <td>{{ get_apply_to(item) }}</td>
          <td>{{ get_date_validite(item) }}</td>
          <td>{{ get_nb_utilisations(item) }}</td>
          <td>
            <v-btn v-if="item.actif == 1" color="error" density="compact" @click="disable_code(item)">Désactiver ce
              code</v-btn>
            <v-btn v-else color="success" density="compact" @click="activate_code(item)">Réactiver ce code</v-btn>
            <!-- <v-btn color="error" density="compact" @click="delete_code(item)">Supprimer</v-btn> -->
          </td>
        </tr>
      </tbody>
    </v-table>
    <v-alert v-else variant="tonal" color="info">Aucun code de réduction pour ce module</v-alert>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

export default {
  props: ["list_code_reduction"],
  data() {
    return {

    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    get_apply_to(item) {
      if (item.apply_to == "courses") {
        return "Les courses";
      } else if (item.apply_to == "options") {
        return "Les options";
      } else {
        return "Les courses et options";
      }
    },
    activate_code(item) {
      this.list_code_reduction.activate_code(item.id);
      this.$emit("onUpdate");
    },
    disable_code(item) {
      this.list_code_reduction.disable_code(item.id);
      this.$emit("onUpdate");
    },
    delete_code(item) {
      this.list_code_reduction.delete_code(item.id);
      this.$emit("onUpdate");
    },
    get_valeur_reduction(item) {
      if (item.type == "Pourcentage") {
        return item.valeur + "%";
      } else {
        return item.valeur + "€";
      }
    },
    get_date_validite(item) {
      if (item.date_validite == "0000-00-00") {
        return "Pas d'expiration";
      } else {
        return this.$moment(item.date_validite).endOf('day').format("DD/MM/YYYY HH:mm");
      }
    },
    get_nb_utilisations(item) {
      if (item.nb_utilisations_max == 0) {
        return item.nb_utilisations + "/Illimité";
      } else {
        return item.nb_utilisations + "/" + item.nb_utilisations_max;
      }
    },
  },
  async created() {
  },
};
</script>

<style lang="scss" scoped></style>